import { render, staticRenderFns } from "./LinkAccount.vue?vue&type=template&id=1cc3eba2&scoped=true"
import script from "./LinkAccount.vue?vue&type=script&lang=js"
export * from "./LinkAccount.vue?vue&type=script&lang=js"
import style0 from "./LinkAccount.vue?vue&type=style&index=0&id=1cc3eba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc3eba2",
  null
  
)

export default component.exports